module.exports = __webpack_public_path__ + "img/logo.c8b276d7.png";